import React from "react";
import { SelectList } from "@common/selectList";
import { AddAllocationIcon } from "@common/assets/addAllocationIcon";
import { ResourceAllocationMenu } from "@common/resourceAllocationMenu";
import { Props } from "./types";
import styles from "./styles.scss";

function ResourceSelect({
  resources,
  addResources,
  removeResources,
  addEveryone,
  isEveryonePending,
}: Props) {
  return (
    <div className={styles.container}>
      <SelectList listClassName={styles.list} multiple>
        {() => ({
          input: <AddAllocationIcon className={styles.icon} />,
          list: (
            <div className={styles.scrollContainer}>
              <ResourceAllocationMenu
                allocatedResources={resources}
                select={addResources}
                unSelect={removeResources}
                everyone={{ select: addEveryone, isPending: isEveryonePending }}
                openedViews={["resources"]}
              />
            </div>
          ),
        })}
      </SelectList>
    </div>
  );
}

export { ResourceSelect };
